import { createApp } from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import { authStore } from './stores/authStore.js'

import './assets/tailwind.css'

const app = createApp(App)

// ===============================
// 🔒 Sesión: cookie e interceptor
// ===============================
// Los componentes importan axios directamente, así que basta con
// configurar la instancia por defecto para cubrirlos a todos.
axios.defaults.withCredentials = true

axios.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    const url = error?.config?.url || ''
    const esLlamadaDeAuth = url.includes('/auth/')

    // Un 401 en cualquier otra llamada significa que la sesión
    // caducó o se cerró: se limpia el estado y se vuelve al login.
    if (error?.response?.status === 401 && !esLlamadaDeAuth) {
      authStore.limpiar()

      if (router.currentRoute.value.path !== '/login') {
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.value.fullPath }
        })
      }
    }

    return Promise.reject(error)
  }
)

// ===============================
// 🚀 DIRECTIVA click-outside
// ===============================
const clickOutsideDirective = {
  beforeMount(el, binding) {
    el.__clickOutsideHandler__ = (e) => {
      if (!(el === e.target || el.contains(e.target))) {
        binding.value(e)
      }
    }
    document.addEventListener('click', el.__clickOutsideHandler__)
  },
  unmounted(el) {
    document.removeEventListener('click', el.__clickOutsideHandler__)
  }
}

app.directive("click-outside", clickOutsideDirective)

// ===============================
// 🚀 Montar app
// ===============================
app.use(router).mount('#app')
